(function AllInclusivePropertiesListing($, Adzuki)
{
	"use strict";

	$(document).ready(function documentReady()
	{
		if ($('.offer_consumer_modal').length > 0) {
			$('.offer_consumer_modal').click(function termsModal(e) {
				e.preventDefault();
				let $modal = $('#modalWindow');
				Adzuki.Ajax.post('/AllInclusiveProperties/getOfferConsumerDetails/', {offer_id: $(this).data('id')})
					.then(function _showAddItems(offer_data) {
						$modal.find('.modal-title').text(offer_data.offer_name);
						$modal.find('.modal-body').html(offer_data.consumer_details);
						$modal.modal('show');
					});
			});
		}

		Adzuki.onload(['/AllInclusiveProperties/index/', '/AllInclusiveProperties/listing/'], function onload() {
			var $results_map = $(".aic-map"),
				data         = $results_map.data('results'),
				// eslint-disable-next-line no-unused-vars
				results_map;

			results_map = new Adzuki.Map($results_map, {
				zoom: 10,
				init: function map_init(map) {
					map.populate(data.map);
				}
			});
		});
	});
}(jQuery, window.Adzuki || {}));